import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { PatientPortalEmailControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientId?: string;
  pagination?: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchString?: string;
  startDate?: string;
  endDate?: string;
  archive?: boolean;
  xTENANTID?: string;
  enabled?: boolean;
}

export const useGetPatientPortalEmails = ({
  patientId,
  pagination,
  gridSorting,
  searchString,
  startDate,
  endDate,
  archive,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  const sortDirect = gridSorting?.[0]?.sort ?? undefined;

  return useQuery({
    queryKey: [
      "patient-portal-emails",
      patientId,
      pagination,
      gridSorting,
      searchString,
      startDate,
      endDate,
      archive,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    enabled: enabled,
    queryFn: async () =>
      new PatientPortalEmailControllerApi(getConfigObject())
        .getAllPatientPortalEmails(
          pagination?.page, // page
          pagination?.pageSize, // size
          undefined, // sortBy
          sortDirect, // sort
          searchString, // searchString
          patientId, // patientId
          startDate, // startDate
          endDate, // endDate
          undefined, // templateTypes
          archive, // archive
          undefined, // sender
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
